import React from 'react';
import { IPhoneShowcase } from './components/IPhoneShowcase';
export function App() {
  return <div className="w-full min-h-screen bg-[#FDF8F3]" data-id="element-0">
      <IPhoneShowcase data-id="element-1" />
    </div>;
}